import React , {useState,useEffect}from 'react'
import {useNavigate } from 'react-router-dom';
import './ViewBooksAdmin.css'
import userApi from '../../Common/Api/UserApi'


const ViewBooksAdmin = () => {

    const [books, setBooks] = useState([]);

    const navigate = useNavigate();
    const editBook = (id)=>{
        navigate(`/dashboard/EditBook/:${id}`)
    }

    const fetchAllBooks = async()=>{
        const res = await userApi.get('/ads');

        console.log("data from /ads : ",res);

        console.log(res.data.approvedAds)
        setBooks(res.data.approvedAds);
    }

    useEffect(() => {
      
        fetchAllBooks();
    
    }, [])
    
  return (
    <div className='req-container'>
        <h2>All Books On Website</h2>
        <div className='row'>
        {
            books.map((element)=>{
                return (
                    <div className=' col-md-6' style={{padding:"1%"}}>
                        <div className="card mb-3" style={{maxWidth:"100%"}} >
                            <div className="row g-0">
                            <div className="col-md-4 hItemImage">
                                <img src={element.images[0]} className="card-image img-fluid rounded-start" alt="..."/>
                            </div>
                            <div className="col-md-8">
                                <div className="card-body">
                                <h5 className="card-title">{element.title}</h5>
                                
                                <h6> Price : {element.price}</h6>
                                <h6> Authors : {element.authors[0]}</h6>
                                
                                {/* <div className='h-photos' onClick={showPhotos} >
                                    <i class="fa-regular fa-images"></i>
                                    Photos
                                </div> */}
                                <p className="card-text"><small className="text-muted">Damaged - {element.damage}%</small></p>
                                <div className='btn-container'>
                                    <p className="card-text"><small className="text-muted">Pages with Markings - {element.markedPages}</small></p>
                                    <button className='main-btn btn item-btn' onClick={()=>editBook(element._id)}>Edit Book</button>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                )
            })
        }
        </div>
    </div>
  )
}

export default ViewBooksAdmin